export const isWisePage = () => {
    const wiseDomain = 'wise.com';
    return window.location.hostname === wiseDomain;
};
